import ActiveIcon from './active.svg';
import ArrowLeftIcon from './arrowLeft.svg';
import ArrowRightIcon from './arrowRight.svg';
import CardsIcon from './cards.svg';
import EditIcon from './edit.svg';
import ExportIcon from './export.svg';
import EyeIcon from './eye.svg';
import GraphIcon from './graph.svg';
import InfoIcon from './info.svg';
import LogoutIcon from './logout.svg';
import MagnifierIcon from './magnifier.svg';
import MenuIcon from './menu.svg';
import PasteIcon from './paste.svg';
import PlayIcon from './play.svg';
import PlaySoundIcon from './playSound.svg';
import PlusIcon from './plus.svg';
import PlusMultipleIcon from './plusMultiple.svg';
import QuestionIcon from './question.svg';
import SettingsIcon from './settings.svg';
import SortIcon from './sort.svg';
import TimeIcon from './time.svg';
import TrashIcon from './trash.svg';
import UndoIcon from './undo.svg';

import { Ref } from 'react';
import { forwardRef } from 'react';

const ICONS = {
  Active: ActiveIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowRight: ArrowRightIcon,
  Cards: CardsIcon,
  Edit: EditIcon,
  Export: ExportIcon,
  Eye: EyeIcon,
  Graph: GraphIcon,
  Info: InfoIcon,
  Logout: LogoutIcon,
  Magnifier: MagnifierIcon,
  Menu: MenuIcon,
  Paste: PasteIcon,
  Play: PlayIcon,
  PlaySound: PlaySoundIcon,
  Plus: PlusIcon,
  PlusMultiple: PlusMultipleIcon,
  Question: QuestionIcon,
  Settings: SettingsIcon,
  Sort: SortIcon,
  Time: TimeIcon,
  Trash: TrashIcon,
  Undo: UndoIcon,
};

type TIconName = keyof typeof ICONS;
function IconImpl(
  {
    icon,
    ...props
  }: React.ComponentProps<TIconComponent> & { icon: TIconName },
  ref?: Ref<SVGSVGElement>
) {
  const Icon = ICONS[icon];
  return <Icon {...props} ref={ref} />;
}

export const Icon = forwardRef(IconImpl);

export default ICONS;
